import React from "react"

import Map from "../map"

import "./Location.scss"

const Location = (props) => {
  return (
    <Map {...props} />
  )
}

export default Location
